import React from 'react';
type DecorativeDandelionsProps = {
  className?: string;
  tone?: 'green' | 'gold';
};
export function DecorativeDandelions({
  className = '',
  tone = 'green'
}: DecorativeDandelionsProps) {
  return <div aria-hidden="true" className={`pointer-events-none absolute select-none botanical-dandelion ${tone === 'gold' ? 'botanical-dandelion--gold' : ''} ${className}`} data-id="element-32" data-mp="13s9udmmidahz">
      <svg viewBox="0 0 190 250" fill="none" className="h-full w-full" xmlns="http://www.w3.org/2000/svg" data-id="element-33" data-mp="1dil820vzuy22">
        <g className="dandelion-stem" stroke="currentColor" strokeWidth="1.5" data-id="element-34" data-mp="1hjwobfsza6xl">
          <path d="M83 244C91 198 97 149 99 89" data-id="element-35" data-mp="1hm116n8uuga0" />
          <path d="M84 196c-20-11-30-12-43-8M89 166c18-14 31-17 45-14M94 133c-15-12-29-17-41-15" data-id="element-36" data-mp="1mkaxj16bfmx7" />
          <circle cx="100" cy="70" r="27" data-id="element-37" data-mp="1rhb37az96nns" />
          <path d="M100 43v54M73 70h54M81 51l38 38M119 51L81 89M91 44l18 52M109 44L91 96M74 61l52 18M74 79l52-18" data-id="element-38" data-mp="1rg9peyqurn2d" />
          <circle cx="100" cy="70" r="4" fill="currentColor" data-id="element-39" data-mp="3t9pkq8xvxq3o" />
        </g>
        <g className="dandelion-seed" stroke="currentColor" strokeWidth="1.2" data-id="element-40" data-mp="3tbtl4gwks6z7">
          <path d="M126 48l22-21M141 34l8-9M142 34l10 1M141 34l-1-10" data-id="element-41" data-mp="8fak2agso94c" />
        </g>
        <g className="dandelion-seed dandelion-seed--two" stroke="currentColor" strokeWidth="1.2" data-id="element-42" data-mp="3ly7wztaxush">
          <path d="M129 70l39-12M158 61l11-4M158 61l8 6M158 61l2-10" data-id="element-43" data-mp="3uuc2vr2l58tt" />
        </g>
        <g className="dandelion-seed dandelion-seed--three" stroke="currentColor" strokeWidth="1.2" data-id="element-44" data-mp="3qs8nircspk39">
          <path d="M124 87l32 7M145 91l10 3M145 91l6-8M145 91l-5 8" data-id="element-45" data-mp="rctvtlun05ug" />
        </g>
      </svg>
    </div>;
}